import { useEffect, useRef } from "react";
import { checkTokenExpiry } from "../api/authCheck";

const CHECK_INTERVAL_MS = 60_000; // Check every 60 seconds

/**
 * Hook that periodically checks if the JWT token has expired
 * and auto-logout (clears auth data + redirect to login) if so.
 *
 * Also runs an initial check on mount.
 */
export default function useAutoLogout() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    // Immediate check on mount
    checkTokenExpiry();

    // Also check when the page/tab becomes visible again (user switches back)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkTokenExpiry();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Periodic check every 60 seconds
    intervalRef.current = setInterval(() => {
      checkTokenExpiry();
    }, CHECK_INTERVAL_MS);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
}
